<span dropdown
[autoClose]="true" container="body">
  <span
  id="dLabel"
  type="button"
  data-toggle="dropdown"
  aria-haspopup="true"
  aria-expanded="false"
  class="dropdown-icon"
  dropdownToggle
>
  <i
    class="feather filter"
    [ngClass]="{
      pinned: currentFilter == 'pinned',
      completed: currentFilter == 'completed',
      unpinned: currentFilter == 'unpinned'
    }"
  ></i>
</span>
<ul
  class="dropdown-menu"
  aria-labelledby="dLabel"
  *dropdownMenu
>
  <li class="dropdown-header">Filter</li>

    <li>
      <a (click)="changeFilter('all')"
        ><i class="feather filter" style="margin-left: 0px"></i> All</a
      >
      <a (click)="changeFilter('unpinned')" *ngIf="showUnpinnedOption"
        ><i class="feather filter unpinned" style="margin-left: 0px"></i>
        Unpinned</a
      >
      <a (click)="changeFilter('pinned')"
        ><i class="tio-pin pinned" style="margin-left: 0px"></i> To-Do</a
      >
      <a (click)="changeFilter('completed')"
        ><i class="tio-pin completed" style="margin-left: 0px"></i>
        Completed</a
      >
    </li>
  </ul>
</span>
